import { useMutation } from '@tanstack/react-query';
import { dispatch } from 'old/store';
import { type ApiClientResponseError, type ResponseErrorDataObject } from 'common/services';
import { updateUserProfile } from '../../services';

export const useUpdateUserProfile = () => {
  return useMutation<
    unknown,
    ApiClientResponseError<ResponseErrorDataObject>,
    { userId: string; userData: { firstName: string; lastName: string; phoneNumber: string; birthdate: string } }
  >({
    async mutationFn({ userId, userData }) {
      const { data } = await updateUserProfile(userId, {
        last_name: userData.lastName,
        first_name: userData.firstName,
        phone: userData.phoneNumber,
        birthdate: userData.birthdate,
      });

      // TODO return model in future
      return data;
    },
    async onSuccess(userData) {
      // TODO remove when we get rid of redux
      await dispatch.session.setUserData(userData);
    },
  });
};
